import { registerFeature } from "lib/features"
import { FEATURE_FLAG_QR_CODES_PDF } from "./server/qr-codes-pdf.mjs"

registerFeature({
    numericalId: 16,
    name: "QR Codes (PDF Booklet)",
    id: FEATURE_FLAG_QR_CODES_PDF,
    description: `Enables the display of QR Codes on PDF Booklet download`,
    readyForProduction: true,
})
